import moment from "moment";
import { CHANGE_TABLE_DATE_RANGE } from "../actions/types";

const INITIAL_STATE = {
  startDate: moment(Date.now()).subtract(24, 'hour').add(1, 'second'),
  endDate: moment(Date.now())
};

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case CHANGE_TABLE_DATE_RANGE:
      return {
        ...state,
        startDate: action.payload.startDate,
        endDate: action.payload.endDate
      };
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/reducers/table_date_range_reducer.js